import banner1 from "../../../assets/images/banner-1.jpg";
import banner2 from "../../../assets/images/banner-2.jpg";
import banner3 from "../../../assets/images/banner-3.jpg";
import banner4 from "../../../assets/images/banner-4.jpg";
import banner5 from "../../../assets/images/banner-5.jpg";

import bannerMobile1 from "../../../assets/images/banner-1-mobile.jpg";
import bannerMobile2 from "../../../assets/images/banner-2-mobile.jpg";
import bannerMobile3 from "../../../assets/images/banner-3-mobile.jpg";
import bannerMobile4 from "../../../assets/images/banner-4-mobile.jpg";
import bannerMobile5 from "../../../assets/images/banner-5-mobile.jpg";

import { useHomeVM } from '../viewmodels/HomeVM';
import { useEffect, useRef } from "react";
import useProductAccessoryVM from "../../products/viewmodels/ProductAccessoryVM";
import TopCategoryItemView from "./TopCategoryItemView";
import TopBrandView from "./TopBrandView";
import useCustomerHomeVM from "../../customers/viewmodels/CustomerHomeVM";
import { HomePageLinkType, ProductKeyModel, ShortLineModel } from "../../products/models/ProductModel";
import HomeProductGridView from "./HomeProductGridView";
import ProductDetailWrapperView from "../../products/views/users/ProductDetailWrapperView";
import { UserProductPictureService } from "../../products/views/users/ProductView";
import PhotoSlideshow from "../../common/views/PhotoSlideshow";
import BrandView from "../../brands/views/BrandView";

export default function HomeView() {
    const pictureService = new UserProductPictureService();

    const hasLoaded = useRef(false);
    const vm = useHomeVM();
    const productAccessoryVM = useProductAccessoryVM();
    const customerHomeVM = useCustomerHomeVM();

    const isMobile = window.innerWidth <= 500;

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        const handleResize = () => {
            const width = window.innerWidth;

            const categorySize = Math.min(width / 4.2, 160);
            productAccessoryVM.setCategorySize(categorySize);

            const brandSize = Math.min(width / 4.2, 100);
            productAccessoryVM.setBrandSize(brandSize);
        }

        window.addEventListener("resize", handleResize);

        vm.onLoad();

        productAccessoryVM.getBrands();
        productAccessoryVM.getCategories();

        customerHomeVM.onLoad();
    }, [vm, productAccessoryVM, customerHomeVM]);

    const createProductKey = (item: ShortLineModel) => {
        const product: ProductKeyModel = {
            groupId: item.groupId,
            lineId: item.id,
            productId: item.productId
        };

        return product;
    }

    const onShowProductDetail = (line: ShortLineModel) => {
        customerHomeVM.setSelectedProduct(line);
        customerHomeVM.setShowProductDetail(true);
    }

    const onCloseProductDetail = () => {
        customerHomeVM.setSelectedProduct(undefined);
        customerHomeVM.setShowProductDetail(false);
    }

    const photos = () => {
        if (isMobile) {
            return [bannerMobile1, bannerMobile2, bannerMobile3, bannerMobile4, bannerMobile5];
        }
        return [banner1, banner2, banner3, banner4, banner5];
    }

    const goProduct = () => {
        window.open("/products", "_self");
    }

    const mainContent = () => {
        return <div>
            <div onClick={goProduct} className="pointer">
                <PhotoSlideshow
                    photos={photos()}
                    aspectRatio={isMobile ? 4 / 3 : 19 / 6}
                />
            </div>

            {productAccessoryVM.categories.length > 0 && <div>
                <div className="font-large font-bold pt-20 ph-10">Categories</div>
                {productAccessoryVM.filteredCategories(["Clearance"]).map((category, index) => {
                    return <>
                        <TopCategoryItemView
                            item={category}
                            size={productAccessoryVM.categorySize}
                        />
                    </>
                })}
            </div>}

            {productAccessoryVM.brands.length > 0 && <div className="pv-20" style={{ display: "flow-root" }}>
                <div className="ph-10 pb-10">
                    <span className="font-large font-bold">Brands</span>
                    <div className="pt-8" style={{ float: "right" }}>
                        <a onClick={() => vm.setShowAllBrands(true)}>See All</a>
                    </div>
                </div>

                <TopBrandView brands={productAccessoryVM.brands} />
            </div>}

            {customerHomeVM.newArrivals.length > 0 && <div className="pv-20" style={{ display: "flow-root" }}>
                <HomeProductGridView
                    title="New Arrivals"
                    type={HomePageLinkType.newArrival}
                    lines={customerHomeVM.newArrivals}
                    isMobile={isMobile}
                    onProductDetail={onShowProductDetail}
                />
            </div>}

            {customerHomeVM.specialSales.length > 0 && <div className="pv-20" style={{ display: "flow-root" }}>
                <HomeProductGridView
                    title="Special Sales"
                    type={HomePageLinkType.specialSale}
                    lines={customerHomeVM.specialSales}
                    isMobile={isMobile}
                    onProductDetail={onShowProductDetail}
                />
            </div>}

            {customerHomeVM.topSales.length > 0 && <div className="pv-20" style={{ display: "flow-root" }}>
                <HomeProductGridView
                    title="Top Sales"
                    type={HomePageLinkType.topSale}
                    lines={customerHomeVM.topSales}
                    isMobile={isMobile}
                    onProductDetail={onShowProductDetail}
                />
            </div>}

            {customerHomeVM.topRates.length > 0 && <div className="pv-20" style={{ display: "flow-root" }}>
                <HomeProductGridView
                    title="Top Rates"
                    type={HomePageLinkType.topRate}
                    lines={customerHomeVM.topRates}
                    isMobile={isMobile}
                    onProductDetail={onShowProductDetail}
                />
            </div>}

            {customerHomeVM.choices.length > 0 && <div className="pv-20" style={{ display: "flow-root" }}>
                <HomeProductGridView
                    title="Best Choices"
                    type={HomePageLinkType.choice}
                    lines={customerHomeVM.choices}
                    isMobile={isMobile}
                    onProductDetail={onShowProductDetail}
                />
            </div>}

            {customerHomeVM.recentViews.length > 0 && <div className="pv-20" style={{ display: "flow-root" }}>
                <HomeProductGridView
                    title="Recent Views"
                    type={HomePageLinkType.recentView}
                    lines={customerHomeVM.recentViews}
                    isMobile={isMobile}
                    onProductDetail={onShowProductDetail}
                />
            </div>}
        </div>;
    }

    return <>
        {mainContent()}

        {customerHomeVM.showProductDetail && customerHomeVM.selectedProduct && <>
            <ProductDetailWrapperView
                product={createProductKey(customerHomeVM.selectedProduct)}
                pictureService={pictureService}
                onClose={onCloseProductDetail}
                isMobile={isMobile}
                addToCart={() => { }}
            />
        </>}

        {vm.showAllBrand && <BrandView onClose={() => vm.setShowAllBrands(false)} />}
    </>;
}